import { SermonSearchRequestSectionWeb } from '@nucleus/types/web/sections/sermon-search-request';
import { useSection } from '@nucleus/web-theme';
import { nucleusClass } from '@nucleus/web-theme-elements';
import classNames from 'classnames';
import React from 'react';
import { getSectionClasses } from '../../lib/classes';
import { Section } from '../../sectionLayouts/Section';
import { SectionLayout } from '../../sectionLayouts/SectionLayout';
import { SermonSearchResultsBlockLayoutContentOnly } from './SermonSearchResultsBlockLayoutContentOnly';

export const SermonSearchResultsSection = (): JSX.Element => {
  const section = useSection<SermonSearchRequestSectionWeb>();

  return (
    <Section className={classNames(nucleusClass('section-search-result'), getSectionClasses(section))}>
      <SectionLayout {...section.payload}>
        <SermonSearchResultsBlockLayoutContentOnly {...section.payload} />
      </SectionLayout>
    </Section>
  );
};
